import { PaginationResponseType } from '@/common/types/ApiResponseTypes.type';
import { fetchApi } from '@/config/axiosSetting';
import {
  WalletFileListQueryParamsType,
  WalletFileListQueryResponseType,
} from './walletFileListQuery.type';

export const walletFileListFunction = (
  params: WalletFileListQueryParamsType,
): Promise<PaginationResponseType<WalletFileListQueryResponseType[]>> => {
  return fetchApi.get('homepage/wallet/file-list/', { params });
};
